import React from 'react';
import Header from './Header';

const withHeader = (Component, hideHeader = false) => {
  const WithHeader = props => {
    const user = JSON.parse(localStorage.getItem('user'));

    const isLoggedIn = !!user;

    if (!isLoggedIn) props.history.push('/dashboard/login');

    if (user?.role !== 'ADMIN') return null;
    return (
      <>
        {!hideHeader && <Header />}
        <Component {...props} />
      </>
    );
  };

  return WithHeader;
};

export default withHeader;
